// dependencies
import React from "react";
import PropTypes from "prop-types";

// components
import Select from "../../../components/Select2";
import { Row, Col } from "../../../components/Grid2";
import SelectCapacity from "../../../components/SelectCapacity";
import CheckBoxForWork from "../../../components/CheckBoxForWork";

// containers
import BookingDatePickerWithTextInput from "../../BookingDatePickerWithTextInput";

// contexts
import { useConfiguration } from "../../../contexts/configuration";

// libraries
import { fromDate, fromString } from "../../../libraries/EnhancedDate";

// helpers
import { roomIsNatureParent, roomHasChildren } from "../../../helpers/room";
import bookingDelegationGetChannelId from "@cloudspire/legacy-resources/src/helpers/booking/delegation/getChannelId";

function BookingAsideForm(props) {
  const {
    type,
    room,
    parameterList,
    inputCheckinRef,
    inputCheckoutRef,
    shouldRenderLegend,
    onChange,
  } = props;

  const configuration = useConfiguration();

  const selectedRoom =
    parameterList?.roomReference === room.reference
      ? room
      : room.children.find(
          (childRoom) => childRoom.reference === parameterList?.roomReference
        );

  return (
    <>
      {"room" === type && (
        <Row type="column" gutter={0.5}>
          <Col>
            <BookingDatePickerWithTextInput
              inputCheckinRef={inputCheckinRef}
              inputCheckoutRef={inputCheckoutRef}
              name="checkinCheckout"
              roomReference={parameterList?.roomReference}
              channelId={bookingDelegationGetChannelId({
                configuration,
                room: selectedRoom,
              })}
              start={
                fromString(parameterList?.checkin ?? null, "Y-m-d") || null
              }
              end={fromString(parameterList?.checkout ?? null, "Y-m-d") || null}
              initialDate={fromDate()}
              min={fromDate().startOfDays()}
              shouldRenderLegend={shouldRenderLegend}
              formatDateOptions={{
                month: "2-digit",
                day: "2-digit",
                year: "2-digit",
              }}
              onSelect={onChange}
            />
          </Col>

          <Col>
            <SelectCapacity
              name="adults"
              min={selectedRoom?.minCapacity}
              max={selectedRoom?.maxCapacity}
              value={parameterList?.adults ?? ""}
              onChange={onChange}
            />
          </Col>

          <Col>
            <CheckBoxForWork
              name="nature"
              value={parameterList?.nature ?? ""}
              onChange={onChange}
            />
          </Col>

          {roomIsNatureParent({ room }) && roomHasChildren({ room }) && (
            <Col>
              <Select
                name="roomReference"
                optionList={room.children.map((childRoom) => ({
                  value: childRoom.reference,
                  label: `${childRoom.name} • ${childRoom.reference}`,
                }))}
                value={parameterList?.roomReference ?? ""}
                onChange={onChange}
              />
            </Col>
          )}
        </Row>
      )}
    </>
  );
}

BookingAsideForm.propTypes = {
  type: PropTypes.oneOf(["booking", "room", "payment"]),
  room: PropTypes.any,
  parameterList: PropTypes.object,
  inputCheckinRef: PropTypes.object,
  inputCheckoutRef: PropTypes.object,
  onChange: PropTypes.func,
};

export default BookingAsideForm;
